module.exports = __webpack_public_path__ + "img/11.42e578b0.png";